import { apiWrapper } from "@/services/api";
import dbsService from "@/services/dbs";
import store from "@/store";

export const getDbsReportsForPast = async (isNotReCall = false) => {
  try {
    const limit = 100;
    let page = 1;
    let url = dbsService.getUrlForReports();
    url += `&limit=${limit}`;

    let resp;
    let respData = [];
    // レスポンスが0になるまで処理を繰り返す。必ず1回は実行したいのでdo-whileを採用。
    do {
      resp = await apiWrapper(
        "GET",
        url + `&page=${page}`,
        {},
        isNotReCall,
        null,
        "Migrated"
      );
      // レスポンスの配列を1つにまとめる。
      Array.prototype.push.apply(respData, resp.data);
      page++;
    } while (resp.data.length == limit);

    store.commit("dbs/setReports", respData);
  } catch (err) {
    console.log('ERROR"" getDbsReportsForPast()');
    throw err;
  }
};
